const STORAGE_KEY = 'merchantPromoRef';
const STORED_AT_KEY = 'merchantPromoRefAt';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

/** 从 URL 捕获 ?ref= / ?promo= 商家推广码，写入本地 30 天 */
export function captureMerchantPromoFromSearch(search: string | URLSearchParams) {
  const params =
    typeof search === 'string' ? new URLSearchParams(search.startsWith('?') ? search : `?${search}`) : search;
  const raw = params.get('ref') || params.get('promo') || '';
  const code = String(raw).trim().toUpperCase();
  if (!code || !/^M[A-Z0-9]{6,20}$/i.test(code)) return null;
  try {
    localStorage.setItem(STORAGE_KEY, code);
    localStorage.setItem(STORED_AT_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
  return code;
}

export function getMerchantPromoCode(): string {
  try {
    const code = String(localStorage.getItem(STORAGE_KEY) || '')
      .trim()
      .toUpperCase();
    const at = Number(localStorage.getItem(STORED_AT_KEY) || 0);
    if (!code) return '';
    if (at && Date.now() - at > TTL_MS) {
      clearMerchantPromoCode();
      return '';
    }
    return code;
  } catch {
    return '';
  }
}

export function clearMerchantPromoCode() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORED_AT_KEY);
  } catch {
    /* ignore */
  }
}
